<template>
  <div>
    <div
      class="eu-pb_5"
      v-for="(recipient, index) in recipientsData"
      :key="index"
    >
      <recipient-header
        v-bind="mountDataHeader(recipient, index)"
        v-if="splits && splits.length > 0"
        :id="`recipientHeader-${index}`"
      />
      <div
        v-else
        class="emd-container _highlight_header no-border"
      >
        <div class="emd-container__header">
          <h2 class="emd-text _size_default _type_caption">
            {{ $t('header') }}
          </h2>
        </div>
      </div>

      <div
        v-if="
          recipient.payable_installment &&
          recipient.payable_installment.length > 0
        "
      >
        <transaction-recipient-installments
          :rows="recipient.payable_installment"
          :formatValue="formatValue"
          v-if="recipient.collapsed"
          :id="`installment-${index}`"
        />
        <div class="footer-collapsed eu-py_3 eu-display_flex eu-justify_center">
          <div
            v-on:click="
              onChangeCollapse(recipient.recipient_id, recipient.collapsed)
            "
            class="emd-text _size_regular"
            v-if="recipient.collapsed"
          >
            {{ $t('charge.detail.recipients.not-collapsed-installments') }}
            <i class="uil uil-angle-up"></i>
          </div>
          <div
            :id="`notCollapsedInstallments-${index}`"
            v-on:click="
              onChangeCollapse(recipient.recipient_id, recipient.collapsed)
            "
            class="emd-text _size_regular"
            v-else
          >
            {{ $t('charge.detail.recipients.collapsed-installments') }}
            <i class="uil uil-angle-down"></i>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import RecipientHeader from './RecipientHeader.vue'
import TransactionRecipientInstallments from './TransactionRecipientInstallments.vue'

export default {
  name: 'Recipients',
  components: {
    RecipientHeader,
    TransactionRecipientInstallments
  },
  props: {
    splits: {
      type: Array
    },
    consolidated: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    recipientsData (newValue) {
      this.recipientsData = newValue
    }
  },
  data () {
    return {
      recipientsData: this.mountDataRecipients(),
      splitsAux: JSON.parse(JSON.stringify(this.splits))
    }
  },
  methods: {
    mountDataHeader (recipient, i = 0) {
      if (this.consolidated.length === 0) {
        return this.getValuesFromSplit(recipient, i)
      }
      const split = this.getSplitsForRecipientId(recipient.recipient_id)
      const consolidated = this.consolidated.find(
        consolidado =>
          consolidado.payble_recipient_id === split.recipient.gateway_id
      )
      const amount =
        split.type === 'Porcentagem'
          ? split.amount
          : this.formatValue(
              consolidated.gross_amount.value,
              consolidated.gross_amount.currency_symbol,
              false
            )
      return this.buildObjectSplit({
        ...split,
        amount,
        netAmount: this.formatValue(
          consolidated.net_amount.value,
          consolidated.net_amount.currency_symbol,
          false
        )
      })
    },
    getValuesFromSplit (recipient) {
      const split = this.getSplitsForRecipientId(recipient.recipient.id, true)
      return this.buildObjectSplit({
        ...split,
        netAmount: null
      })
    },
    buildObjectSplit (split) {
      return {
        name: split.recipient.name,
        idRecipient: split.recipient.id,
        netAmount: split.netAmount,
        amount: split.amount,
        liable: this.checkValueIsTrue(split.options?.liable),
        chargeProcessingFee: this.checkValueIsTrue(
          split.options?.charge_processing_fee
        )
      }
    },
    checkValueIsTrue (value) {
      return value === 'Sim'
    },
    getSplitsForRecipientId (id, aux) {
      if (aux) {
        const indexOfRecipient = this.splitsAux.findIndex(
          splitRule => splitRule?.recipient?.id === id
        )
        const splitToReturn = this.splitsAux[indexOfRecipient]

        this.splitsAux[indexOfRecipient] = null
        // eslint-disable-next-line
        return splitToReturn
      }
      return this.splits.find(splitRule => splitRule?.recipient?.id === id)
    },
    mountDataRecipients () {
      if (this.consolidated.length === 0) {
        return this.splits
      }

      return this.consolidated.map(recipient => ({
        ...recipient,
        collapsed: false
      }))
    },
    formatValue (value, currencySymbol, showPlusSign = true) {
      const formatter = new Intl.NumberFormat('pt-BR', {
        minimumFractionDigits: 2
      })
      const onlyNumbers = this.removeMinusSign(value)
      const operationShow = this.getSign(value, showPlusSign)
      return `${operationShow} ${currencySymbol} ${formatter.format(
        onlyNumbers
      )}`
    },
    removeMinusSign (value) {
      if (String(value).indexOf('-') === 0) {
        return String(value).slice(1)
      }
      return value
    },
    getSign (value, showPlusSign) {
      if (value === 0) {
        return ''
      }
      const isGreaterThanOne = value > 0

      if (!showPlusSign && isGreaterThanOne) {
        return ''
      }

      return isGreaterThanOne ? '+' : '-'
    },
    onChangeCollapse (id, collapsed) {
      const recipients = this.recipientsData
      const item = recipients.map(recipient => {
        if (recipient.recipient_id === id) {
          return { ...recipient, collapsed: !collapsed }
        }
        return recipient
      })
      this.recipientsData = item
    }
  }
}
</script>
<style scoped>
.footer-collapsed {
  background-color: var(--color-white);
  cursor: pointer;
}
</style>
<i18n>
  {
    "pt-BR": {
      "header": "Parcelas do recebimento"
    },
    "en-US": {
      "header":  "Installments of the payment"
    }
  }
</i18n>
